module.exports = __webpack_public_path__ + "assets/img/four.8bf10af9.jpg";